// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
    position: relative;
    margin: 10px auto;
    width: 60px;
}

.loader::before {
    content: '';
    display: block;
    padding-top: 100%;
}

.circular {
    animation: rotate 2s linear infinite;
    height: 60px;
    transform-origin: center center;
    width: 60px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}

.path {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
    stroke-linecap: round;
}

@keyframes rotate {
    100% {
        transform: rotate(360deg);
    }
}

@keyframes dash {
    0% {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -35px;
    }
    100% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -124px;
    }
}

@keyframes color {
    100%,
    0% {
        stroke: #d62d20;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #008744;
    }
    80%,
    90% {
        stroke: #ffa700;
    }
}

.snackbar {
    visibility: hidden;
    position: fixed;
    z-index: 10000;
    bottom: 30px;
    width: 100%;
    left: 0;
    right: 0;
    text-align: center;
}

.snackbar.show {
    visibility: visible;
    -webkit-animation: fadein 0.5s, fadeout .5s 5s;
    animation: fadein 0.5s, fadeout .5s 5s
}

.snackbar .content {
    background-color: #333;
    color: #fff;
    border-radius: 2px;
    padding: 16px;
    display: inline-block;
    max-width: 80%;
}

@-webkit-keyframes fadein {
    from {
        bottom: 0;
        opacity: 0
    }
    to {
        bottom: 30px;
        opacity: 1
    }
}

@keyframes fadein {
    from {
        bottom: 0;
        opacity: 0
    }
    to {
        bottom: 30px;
        opacity: 1
    }
}

@-webkit-keyframes fadeout {
    from {
        bottom: 30px;
        opacity: 1
    }
    to {
        bottom: 0;
        opacity: 0
    }
}

@keyframes fadeout {
    from {
        bottom: 30px;
        opacity: 1
    }
    to {
        bottom: 0;
        opacity: 0
    }
}

.modal2 {
    position: fixed;
    z-index: 10000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.9);
}

.closeimg {
    cursor: pointer;
    position: absolute;
    top: 15px;
    right: 35px;
    color: #f1f1f1;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
    z-index: 100;
}

.modal-content2 {
    margin: auto;
    display: block;
    width: 100%;
    height: 100vh !important;
    max-width: 700px;
    object-fit: contain;
}

.modal-content2, #caption {
    -webkit-animation-name: zoom;
    -webkit-animation-duration: 0.3s;
    animation-name: zoom;
    animation-duration: 0.3s;
}

#caption {
    width: 100%;
    top: 0px;
    position: absolute;
    margin: auto;
    display: block;
    text-align: center;
    color: #222;
    padding: 10px 0;
}

#caption span {
    background: #fff;
    padding: 8px 10px;
    min-width: 100px;
    display: inline-block;
    border-radius: 5px;
}

.alert-popup {
    left: 0px;
    transition: 0.3s;
    z-index: 1000000;
    position: fixed;
    top: -80px;
    width: 100%;
}

.alert-popup.open-alert-popup {
    top: 10px;
}

.alert-message-container {
    width: 450px;
    margin: auto;
    display: flex;
}

.alert-message {
    padding: 15px 20px;
    font-size: 15px;
    background-color: #d9534f;
    color: #FFFFFF;
    display: inline-block;
    vertical-align: middle;
    width: 400px;
}

.success {
    background-color: lightgreen;
}

.alert-close {
    outline: none !important;
    border: none;
    border-left: 1px solid #FFFFFF;
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
    padding: 15px 20px;
    background-color: #333333;
    color: #FFFFFF;
}

.alert-close:hover {
    background-color: #222222;
}

@-webkit-keyframes zoom {
    from {
        -webkit-transform: scale(0)
    }
    to {
        -webkit-transform: scale(1)
    }
}

@keyframes zoom {
    from {
        transform: scale(0)
    }
    to {
        transform: scale(1)
    }
}

@-webkit-keyframes fadein {
    from {
        bottom: 0;
        opacity: 0
    }
    to {
        bottom: 30px;
        opacity: 1
    }
}

@keyframes fadein {
    from {
        bottom: 0;
        opacity: 0
    }
    to {
        bottom: 30px;
        opacity: 1
    }
}

@-webkit-keyframes fadeout {
    from {
        bottom: 30px;
        opacity: 1
    }
    to {
        bottom: 0;
        opacity: 0
    }
}

@keyframes fadeout {
    from {
        bottom: 30px;
        opacity: 1
    }
    to {
        bottom: 0;
        opacity: 0
    }
}
`, "",{"version":3,"sources":["webpack://./client/components/styles/loader.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,+BAA+B;IAC/B,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;IACpB,wEAAwE;IACxE,qBAAqB;AACzB;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB,oBAAoB;IACxB;IACA;QACI,yBAAyB;QACzB,wBAAwB;IAC5B;IACA;QACI,yBAAyB;QACzB,yBAAyB;IAC7B;AACJ;;AAEA;IACI;;QAEI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;;QAEI,eAAe;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,WAAW;IACX,OAAO;IACP,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,8CAA8C;IAC9C;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI;QACI,SAAS;QACT;IACJ;IACA;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI;QACI,SAAS;QACT;IACJ;IACA;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;IACA;QACI,SAAS;QACT;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;IACA;QACI,SAAS;QACT;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,cAAc;IACd,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,WAAW;IACX,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,gCAAgC;IAChC,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI;IACJ;IACA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;IACA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,SAAS;QACT;IACJ;IACA;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI;QACI,SAAS;QACT;IACJ;IACA;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;IACA;QACI,SAAS;QACT;IACJ;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;IACA;QACI,SAAS;QACT;IACJ;AACJ","sourcesContent":[".loader {\n    position: relative;\n    margin: 10px auto;\n    width: 60px;\n}\n\n.loader::before {\n    content: '';\n    display: block;\n    padding-top: 100%;\n}\n\n.circular {\n    animation: rotate 2s linear infinite;\n    height: 60px;\n    transform-origin: center center;\n    width: 60px;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n}\n\n.path {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n    animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;\n    stroke-linecap: round;\n}\n\n@keyframes rotate {\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes dash {\n    0% {\n        stroke-dasharray: 1, 200;\n        stroke-dashoffset: 0;\n    }\n    50% {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: -35px;\n    }\n    100% {\n        stroke-dasharray: 89, 200;\n        stroke-dashoffset: -124px;\n    }\n}\n\n@keyframes color {\n    100%,\n    0% {\n        stroke: #d62d20;\n    }\n    40% {\n        stroke: #0057e7;\n    }\n    66% {\n        stroke: #008744;\n    }\n    80%,\n    90% {\n        stroke: #ffa700;\n    }\n}\n\n.snackbar {\n    visibility: hidden;\n    position: fixed;\n    z-index: 10000;\n    bottom: 30px;\n    width: 100%;\n    left: 0;\n    right: 0;\n    text-align: center;\n}\n\n.snackbar.show {\n    visibility: visible;\n    -webkit-animation: fadein 0.5s, fadeout .5s 5s;\n    animation: fadein 0.5s, fadeout .5s 5s\n}\n\n.snackbar .content {\n    background-color: #333;\n    color: #fff;\n    border-radius: 2px;\n    padding: 16px;\n    display: inline-block;\n    max-width: 80%;\n}\n\n@-webkit-keyframes fadein {\n    from {\n        bottom: 0;\n        opacity: 0\n    }\n    to {\n        bottom: 30px;\n        opacity: 1\n    }\n}\n\n@keyframes fadein {\n    from {\n        bottom: 0;\n        opacity: 0\n    }\n    to {\n        bottom: 30px;\n        opacity: 1\n    }\n}\n\n@-webkit-keyframes fadeout {\n    from {\n        bottom: 30px;\n        opacity: 1\n    }\n    to {\n        bottom: 0;\n        opacity: 0\n    }\n}\n\n@keyframes fadeout {\n    from {\n        bottom: 30px;\n        opacity: 1\n    }\n    to {\n        bottom: 0;\n        opacity: 0\n    }\n}\n\n.modal2 {\n    position: fixed;\n    z-index: 10000;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    background-color: rgb(0, 0, 0);\n    background-color: rgba(0, 0, 0, 0.9);\n}\n\n.closeimg {\n    cursor: pointer;\n    position: absolute;\n    top: 15px;\n    right: 35px;\n    color: #f1f1f1;\n    font-size: 40px;\n    font-weight: bold;\n    transition: 0.3s;\n    z-index: 100;\n}\n\n.modal-content2 {\n    margin: auto;\n    display: block;\n    width: 100%;\n    height: 100vh !important;\n    max-width: 700px;\n    object-fit: contain;\n}\n\n.modal-content2, #caption {\n    -webkit-animation-name: zoom;\n    -webkit-animation-duration: 0.3s;\n    animation-name: zoom;\n    animation-duration: 0.3s;\n}\n\n#caption {\n    width: 100%;\n    top: 0px;\n    position: absolute;\n    margin: auto;\n    display: block;\n    text-align: center;\n    color: #222;\n    padding: 10px 0;\n}\n\n#caption span {\n    background: #fff;\n    padding: 8px 10px;\n    min-width: 100px;\n    display: inline-block;\n    border-radius: 5px;\n}\n\n.alert-popup {\n    left: 0px;\n    transition: 0.3s;\n    z-index: 1000000;\n    position: fixed;\n    top: -80px;\n    width: 100%;\n}\n\n.alert-popup.open-alert-popup {\n    top: 10px;\n}\n\n.alert-message-container {\n    width: 450px;\n    margin: auto;\n    display: flex;\n}\n\n.alert-message {\n    padding: 15px 20px;\n    font-size: 15px;\n    background-color: #d9534f;\n    color: #FFFFFF;\n    display: inline-block;\n    vertical-align: middle;\n    width: 400px;\n}\n\n.success {\n    background-color: lightgreen;\n}\n\n.alert-close {\n    outline: none !important;\n    border: none;\n    border-left: 1px solid #FFFFFF;\n    cursor: pointer;\n    display: inline-block;\n    vertical-align: middle;\n    padding: 15px 20px;\n    background-color: #333333;\n    color: #FFFFFF;\n}\n\n.alert-close:hover {\n    background-color: #222222;\n}\n\n@-webkit-keyframes zoom {\n    from {\n        -webkit-transform: scale(0)\n    }\n    to {\n        -webkit-transform: scale(1)\n    }\n}\n\n@keyframes zoom {\n    from {\n        transform: scale(0)\n    }\n    to {\n        transform: scale(1)\n    }\n}\n\n@-webkit-keyframes fadein {\n    from {\n        bottom: 0;\n        opacity: 0\n    }\n    to {\n        bottom: 30px;\n        opacity: 1\n    }\n}\n\n@keyframes fadein {\n    from {\n        bottom: 0;\n        opacity: 0\n    }\n    to {\n        bottom: 30px;\n        opacity: 1\n    }\n}\n\n@-webkit-keyframes fadeout {\n    from {\n        bottom: 30px;\n        opacity: 1\n    }\n    to {\n        bottom: 0;\n        opacity: 0\n    }\n}\n\n@keyframes fadeout {\n    from {\n        bottom: 30px;\n        opacity: 1\n    }\n    to {\n        bottom: 0;\n        opacity: 0\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
